import { defineComponent as _defineComponent } from 'vue';
import {} from "@fortawesome/fontawesome-svg-core";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useNotificationsStore } from "@/stores/notificationsStore";
import ActivityItem from "@/components/ActivityBar/ActivityItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationItem',
    props: {
        id: null,
        title: null,
        icon: null,
        isActive: { type: Boolean }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const { totalUnreadCount } = storeToRefs(useNotificationsStore());
        const tooltip = computed(() => totalUnreadCount.value > 0
            ? `You have ${totalUnreadCount.value} unread notifications`
            : "You have no unread notifications");
        return { __sfc: true, totalUnreadCount, emit, tooltip, ActivityItem };
    }
});
